import React from 'react';
import { FormattedText } from 'core/i18n';

export const OlderContainer = ({ visibility, handleOnClick, id }) => (
    <div className={visibility ? 'age-restriction' : 'hidden'} id={id}>
        <div className="prospects-gutter prospects-separator">
            <div className="row">
                <div className="col-xs-12">
                    <i className="icons icons--icon-plus-eighteen" />
                    <h5 className="font-heading5 age-restriction__title">
                        <FormattedText value="initial-thankYouInterested" />
                    </h5>
                    <span className="dash" />
                    <p className="font-paragraph2 age-restriction__description">
                        <FormattedText value="initial-sorryMessage" />
                    </p>
                    <div>
                        <i className="icons icons--icon-phone-blue" />
                        <p className="font-paragraph2 age-restriction__call-center">
                            <FormattedText value="initial-contactMessage" />
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className="form__footer form__footer-inner">
            <div className="text-right">
                <button type="button" className="form__button form__button-secondary" onClick={handleOnClick}>
                    <FormattedText value="button-understood" />
                </button>
            </div>
        </div>
    </div>
);
